<template>
  <div
    ref="table"
    class="c-table"
    :class="{
      'c-table_scrolled': isScrolled,
      'c-table_scroll_end': isScrollEnd,
      'c-table_scroll': isScroll,
    }"
  >
    <m-column-filters
      ref="columnFilters"
      :column="filteredColumn"
      :reference-list="referenceList"
      :active-filters="activeFilteredColumns"
      @getReferenceValues="getReferenceValues"
      @close="filteredColumn = null"
      @setFilter="setColumnFilter"
      @removeFilter="removeColumnFilter"
    />

    <div
      v-if="data.records.length !== 0"
      :class="{
        'c-table__shadow': data.actions,
        'c-table__shadow_active': data.actions,
        // 'c-table__empty__shadow': data.records.length === 0
      }"
    ></div>
    <div v-if="isScroll" class="c-table__scrollbar-wrapper"></div>

    <!--    <perfect-scrollbar class="c-table__wrapper" ref="wrapper" @scroll="scroll">-->
    <table ref="container" class="c-table__container">
      <thead ref="header" class="c-table__header">
        <tr v-for="i in levels" :key="i" class="c-table__header-row">
          <th
            v-for="column in getTableColumns(i)"
            :id="`c-table-column-${column.id}`"
            :key="column.id"
            class="c-table__column"
            :colspan="getColspan(column)"
            :rowspan="getRowspan(column)"
            :class="{
              'c-table__column_with_filter': column.type,
              'c-table__column_hidden': isDisabled(column.id),
              'c-table__column_sorted': isSorted(column),
            }"
          >
            <div class="c-table__column-wrapper">
              <div
                class="c-table__column-label"
                :class="{ 'c-table__column-label-children': !isCategory(column) && sortedColumn }"
                @click="setSortedColumn(column, sortedColumn)"
              >
                {{ column.label }}
              </div>
            </div>
          </th>

          <th v-if="data.actions && i === 1" class="c-table__column c-table__column_actions" :rowspan="levels">
            <div class="c-table__column-empty"></div>
          </th>
        </tr>
      </thead>

      <tbody class="c-table__records">
        <template v-for="(record, recordIndex) in data.records" >
          <template>
            <tr :key="recordIndex" class="c-table__record" :class="{ order_warning: record.warning }">
              <td
                v-for="column in getTableColumns(levels)"
                :key="column.id"
                class="c-table__cell"
                :class="{
                  'c-table__cell_string': column.type === 'string',
                  'c-table__cell_reference': column.type === 'reference',
                  'c-table__cell_number': column.type === 'number',
                  'c-table__cell_date': column.type === 'date',
                  'c-table__cell_hidden': isDisabled(column.id),
                  ['c-table__cell_' + column.id]: column.id,
                }"
              >
                <div
                  v-if="column.id === 'processed' || column.id === 'estimated_actual_travel_time'"
                  class="c-table__cell-value c-table__cell-value__processed"
                >
                  {{ record[column.id].value }}
                  <svg
                    v-if="isShowNestedOrdersInRoutesTab"
                    v-b-toggle="recordIndex.toString()"
                    class="c-table__cell-value__processed-button"
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="11" cy="11" r="10.5" fill="white" stroke="#D3D8DF" />
                    <path
                      d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
                      fill="#0066FF"
                    />
                    <path
                      d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
                      fill="#0066FF"
                    />
                  </svg>
                </div>
                <div v-else class="c-table__cell-value" v-html="record[column.id].value">
                  {{ record[column.id].value }} {{record.warning}}
                </div>
              </td>
            </tr>
            <b-collapse
              v-if="activeTab === 'orders'"
              :id="recordIndex.toString()"
              :key="`${recordIndex}-collapse`"
              tag="tr"
              class="c-table__record c-table__record-collapse"
            >
              <td colspan="4" class="c-table__record-collapse-cell">
                <div class="c-table__record-collapse-header">
                  <div class="c-table__record-collapse-header-title">Состав заказа</div>
                  <div class="c-table__record-collapse-header-sum">
                    {{ numberWithSpaces(record.orderList.sum) }}
                    ฿
                  </div>
                </div>
                <table class="c-table__record-collapse-table">
                  <tbody>
                    <tr v-for="item in record.orderList.items" :key="item.name+recordIndex">
                      <td>{{ item.name }}</td>
                      <td>{{ item.count }}</td>
                      <td>{{ item.summ }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="c-table__record-collapse-row">
                  <div class="c-table__record-collapse-row-col">
                    <div class="c-table__record-collapse-row-col-title">История изменений</div>
                    <table class="c-table__record-collapse-table c-table__record-collapse-table-history-changes">
                      <tbody>
                        <tr
                          v-for="(item, itemIndex) in record.historyChanges"
                          :key="`${itemIndex}-table-record`"
                          :class="{
                            'c-table__record-collapse-table-row-red': item.d === 2,
                            'c-table__record-collapse-table-row-lightred': item.d === 1,
                            'c-table__record-collapse-table-row-yellow': item.d === 0,
                          }"
                        >
                          <td>{{ item.desc }}</td>
                          <td class="c-table__record-collapse-table-cell-bold">{{ item.time }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="c-table__record-collapse-row-col">
                    <div class="c-table__record-collapse-row-col-operator">
                      <div class="c-table__record-collapse-row-col-operator-title">Оператор</div>
                      <div class="c-table__record-collapse-row-col-operator-name">
                        {{ record.operator }}
                      </div>
                    </div>
                    <div class="c-table__record-collapse-row-col-driver">
                      <div class="c-table__record-collapse-row-col-driver-title">Водитель</div>
                      <c-input
                        v-model="record.currentDriver"
                        type="select"
                        :items="record.drivers"
                        v-if="record.drivers && record.drivers.length"
                        placeholder="Выберите водителя"
                        @input="ChangeDriver(record)"
                      />
                      <div class="c-table__record-collapse-row-col-operator-name" v-if="!record.drivers || !record.drivers.length">
                        {{ record.courier }}
                      </div>
                    </div>
                    <div class="c-table__record-collapse-row-col-delivery">
                      <div class="c-table__record-collapse-row-col-delivery-title">Доставка</div>
                      <div class="c-table__record-collapse-row-col-delivery-items">
                        <div class="c-table__record-collapse-row-col-delivery-items-item">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                              stroke="#8E9CBB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {{ record.delivery.when_delivered }}
                        </div>
                        <div class="c-table__record-collapse-row-col-delivery-items-item">
                          <svg
                            width="14"
                            height="14"
                            viewBox="0 0 14 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                              stroke="#8E9CBB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <circle cx="7" cy="10" r="1" fill="#8E9CBB" />
                          </svg>
                          {{ record.delivery.elapsed_time }}
                        </div>
                        <div class="c-table__record-collapse-row-col-delivery-items-item">
                          <svg
                            width="14"
                            height="17"
                            viewBox="0 0 14 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13 7C13 11.6667 7 15.6667 7 15.6667C7 15.6667 1 11.6667 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
                              stroke="#8E9CBB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"
                              stroke="#8E9CBB"
                              stroke-width="2"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          {{ record.delivery.point }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </b-collapse>

            <b-collapse
              v-if="activeTab === 'routes'"
              :id="recordIndex.toString()"
              :key="`${recordIndex}-routes-collapse`"
              tag="tr"
              class="c-table__record c-table__record-collapse"
            >
              <td colspan="4" class="c-table__record-collapse-cell c-table__record-collapse-cell-grey">
                <table class="c-table__record-collapse-routes-order-table">
                  <thead class="c-table__header">
                    <tr class="c-table__header-row">
                      <th class="c-table__column">
                        <div class="c-table__column-wrapper">
                          <div class="c-table__column-label">№ заказа</div>
                        </div>
                      </th>
                      <th class="c-table__column">
                        <div class="c-table__column-wrapper">
                          <div class="c-table__column-label">Старт обработки</div>
                        </div>
                      </th>
                      <th class="c-table__column">
                        <div class="c-table__column-wrapper">
                          <div class="c-table__column-label">Окончание обработки</div>
                        </div>
                      </th>
                      <th class="c-table__column">
                        <div class="c-table__column-wrapper">
                          <div class="c-table__column-label">Сумма заказа, ฿</div>
                        </div>
                      </th>
                      <th class="c-table__column">
                        <div class="c-table__column-wrapper">
                          <div class="c-table__column-label">Обработал</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-for="(item, indexNested) in record.orders">
                      <tr :key="`${indexNested}-table-cell-value`" :class="{ order_warning: item.warning }">
                        <td class="c-table__cell c-table__cell__white">
                          <div class="c-table__cell-value">
                            {{ item.number }}
                          </div>
                        </td>
                        <td class="c-table__cell c-table__cell__white">
                          <div class="c-table__cell-value">
                            {{ item.start_time }}
                          </div>
                        </td>
                        <td class="c-table__cell c-table__cell__white">
                          <div class="c-table__cell-value">
                            {{ item.close_time }}
                          </div>
                        </td>
                        <td class="c-table__cell c-table__cell__white">
                          <div class="c-table__cell-value">
                            {{ item.sum }}
                          </div>
                        </td>
                        <td class="c-table__cell c-table__cell__white">
                          <div class="c-table__cell-value c-table__cell-value__processed">
                            {{ item.operator }}
                            <svg
                              v-b-toggle="indexNested.toString() + recordIndex.toString() + 'nested'"
                              class="c-table__cell-value__processed-button"
                              width="22"
                              height="22"
                              viewBox="0 0 22 22"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <circle cx="11" cy="11" r="10.5" fill="white" stroke="#D3D8DF" />
                              <path
                                d="M10.5398 13.4727C10.2813 13.2141 10.2813 12.7948 10.5398 12.5361L13.87 9.20431C14.1285 8.94569 14.5476 8.94569 14.8061 9.20432C15.0646 9.46294 15.0646 9.88225 14.8061 10.1409L11.4759 13.4727C11.2174 13.7313 10.7983 13.7313 10.5398 13.4727Z"
                                fill="#0066FF"
                              />
                              <path
                                d="M11.4706 13.4727C11.7291 13.2141 11.7291 12.7948 11.4706 12.5361L8.12999 9.19397C7.87149 8.93534 7.45238 8.93534 7.19388 9.19397C6.93537 9.45259 6.93537 9.8719 7.19388 10.1305L10.5345 13.4727C10.793 13.7313 11.2121 13.7313 11.4706 13.4727Z"
                                fill="#0066FF"
                              />
                            </svg>
                          </div>
                        </td>
                      </tr>
                      <b-collapse
                        :id="indexNested.toString() + recordIndex.toString() + 'nested'"
                        :key="`${indexNested}-nested-collapse`"
                        tag="tr"
                        class="c-table__record c-table__record-collapse"
                      >
                        <td class="c-table__record-collapse-cell" colspan="5">
                          <div class="c-table__record-collapse-header">
                            <div class="c-table__record-collapse-header-title">Состав заказа</div>
                            <div class="c-table__record-collapse-header-sum">
                              {{ numberWithSpaces(item.sum) }}
                              ฿
                            </div>
                          </div>
                          <table class="c-table__record-collapse-table">
                            <tbody>
                              <tr v-for="product in item.items" :key="product.name+recordIndex+indexNested">
                                <td>{{ product.name }}</td>
                                <td>{{ product.amount }}</td>
                                <td>{{ product.sum }}</td>
                              </tr>
                            </tbody>
                          </table>
                          <div class="c-table__record-collapse-row">
                            <div class="c-table__record-collapse-row-col">
                              <div class="c-table__record-collapse-row-col-title">История изменений 3</div>
                              <table
                                class="c-table__record-collapse-table c-table__record-collapse-table-history-changes"
                              >
                                <tbody>
                                  <tr
                                    v-for="historyItem in item.history"
                                    :key="`${historyItem.t}-history-item`"
                                    :class="{
                                      'c-table__record-collapse-table-row-red': historyItem.d === 2,
                                      'c-table__record-collapse-table-row-lightred': historyItem.d === 1,
                                      'c-table__record-collapse-table-row-yellow': historyItem.d === 0,
                                    }"
                                  >
                                    <td>{{ historyItem.n }}</td>
                                    <td class="c-table__record-collapse-table-cell-bold">{{ historyItem.t }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <div class="c-table__record-collapse-row-col">
                              <div class="c-table__record-collapse-row-col-operator">
                                <div class="c-table__record-collapse-row-col-operator-title">Оператор</div>
                                <div class="c-table__record-collapse-row-col-operator-name">
                                  {{ item.operator }}
                                </div>
                              </div>
                              <div class="c-table__record-collapse-row-col-driver">
                                <div class="c-table__record-collapse-row-col-driver-title">Водитель</div>
                                <c-input
                                  v-model="record.currentDriver"
                                  type="select"
                                  placeholder="Выберите водителя"
                                  :items="record.drivers"
                                  v-if="record.drivers && record.drivers.length"
                                />
                                <div class="c-table__record-collapse-row-col-operator-name" v-if="!record.drivers || !record.drivers.length">
                                  {{ item.courier }}
                                </div>
                              </div>
                              <div class="c-table__record-collapse-row-col-delivery">
                                <div class="c-table__record-collapse-row-col-delivery-title">Доставка</div>
                                <div class="c-table__record-collapse-row-col-delivery-items">
                                  <div class="c-table__record-collapse-row-col-delivery-items-item">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7 4V7L9 8M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                                        stroke="#8E9CBB"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    {{ item.delivery.time[0] + " " + item.delivery.time[1] }}
                                  </div>
                                  <div class="c-table__record-collapse-row-col-delivery-items-item">
                                    <svg
                                      width="14"
                                      height="14"
                                      viewBox="0 0 14 14"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M7 4V7M13 7C13 10.3137 10.3137 13 7 13C3.68629 13 1 10.3137 1 7C1 3.68629 3.68629 1 7 1C10.3137 1 13 3.68629 13 7Z"
                                        stroke="#8E9CBB"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <circle cx="7" cy="10" r="1" fill="#8E9CBB" />
                                    </svg>
                                    {{ getTimeDifference(item.start_time, item.close_time) }}
                                  </div>
                                  <div class="c-table__record-collapse-row-col-delivery-items-item">
                                    <svg
                                      width="14"
                                      height="17"
                                      viewBox="0 0 14 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13 7C13 11.6667 7 15.6667 7 15.6667C7 15.6667 1 11.6667 1 7C1 5.4087 1.63214 3.88258 2.75736 2.75736C3.88258 1.63214 5.4087 1 7 1C8.5913 1 10.1174 1.63214 11.2426 2.75736C12.3679 3.88258 13 5.4087 13 7Z"
                                        stroke="#8E9CBB"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                      <path
                                        d="M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z"
                                        stroke="#8E9CBB"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                      />
                                    </svg>
                                    {{ item.delivery.address }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>
                      </b-collapse>
                    </template>
                  </tbody>
                </table>
              </td>
            </b-collapse>
          </template>
        </template>
        <tr v-if="activeTab === 'orders' && data.records.length > 0" class="c-table__record">
          <td class="c-table__record__total__cell" colspan="2">
            <div class="c-table__record__total">
              <div class="c-table__record__total__value">
                <div class="c-table__record__total__value__desc">Всего заказов:</div>
                <div class="c-table__record__total__value__count">{{ data.records.length }}</div>
              </div>

            </div>
          </td>
          <td class="c-table__record__total__cell" colspan="2">
            <div class="c-table__record__total">
              <div class="c-table__record__total__value">
                <div class="c-table__record__total__value__desc">Сумма заказов:</div>
                <div class="c-table__record__total__value__count">
                  {{
                    Math.round(data.records.reduce((a, b) => {
                      return a + b.summ_order.value;
                    }, 0)*100)/100
                  }}
                </div>
              </div>
            </div>
          </td>
        </tr>
        <tr  class="c-table__record">
          <td class="c-table__record__total__cell" colspan="4" style="padding: 10px">
            <c-button
              class="delivery-header-buttons-left-recalculate-routes"
              icon="routes"
              label="Пересчитать маршруты"
              size="small"
              @click="recountDriver(data)"
              responsive
            />
          </td>
        </tr>

      </tbody>
    </table>

    <div v-if="data.records.length === 0" class="c-table__empty__records">{{ emptyRecordsLabel }}</div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";

import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";
import ColumnFiltersModal from "@/components/modals/column-filters";


export default {
  name: "c-table",
  components: {
    "c-button": Button,
    "c-input": Input,
    "m-column-filters": ColumnFiltersModal,
  },
  props: [
    "levels",
    "maxWidth",
    "data",
    "enabledFields",
    "disabledColumns",
    "sortedColumn",
    "filteredColumns",
    "activeFilteredColumns",
    "referenceList",
    "emptyRecordsLabel",
    "activeTab",
    "isShowNestedOrdersInRoutesTab",
  ],
  data() {
    return {
      isScrolled: false,
      isScrollEnd: false,
      isScroll: false,
      positionTop: 0,
      filterFieldsBlockHeight: 0,
      filteredColumn: null,
    };
  },

  computed: {
    ...mapGetters("app", ["sidebarCollapsed"]),

    // sortedRecords: function() {
    //   if (!this.sortedColumn) {
    //     return this.data.records
    //   }
    //
    //   let sortedColumn = this.sortedColumn.sortBy
    //   let sortType = (this.sortedColumn.sortType === 'asc') ? 1 : -1
    //   let sortedColumns
    //
    //   if (sortedColumn === 'created') {
    //     sortedColumns = this.data.records.sort(function(a, b) {
    //       let dateA = moment(a[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       let dateB = moment(b[sortedColumn].value, "DD-MM-YYYY").format('X')
    //       if (isNaN(dateA) || isNaN(dateB)) {
    //         return 0
    //       }
    //       if (sortType === -1) {
    //         return (dateB > dateA) ? 1 : (dateA > dateB) ? -1 : 0;
    //       } else if (sortType === 1) {
    //         return (dateA > dateB) ? 1 : (dateB > dateA) ? -1 : 0;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   } else {
    //     sortedColumns = this.data.records.sort(function (a, b) {
    //       if (a[sortedColumn].value.toLowerCase() < b[sortedColumn].value.toLowerCase()) {
    //         return -1 * sortType;
    //       } else if (a[sortedColumn].value > b[sortedColumn].value) {
    //         return 1 * sortType;
    //       } else {
    //         return 0;
    //       }
    //     })
    //   }
    //
    //   return sortedColumns
    // }
  },

  watch: {
    "enabledFields": function () {
      this.updatePositionTop();
    },

    "isScrollEnd": function () {
      // console.log('value: ', value)
    },

    "data" : function(v) {
      console.log(v);
    },
    "data.columns": function () {
      // console.log('value: ', value)
    },

    "disabledColumns": function (value) {
      const enabledColumns = this.data.columns.filter((item) => !value.includes(item.id));

      const max = Math.max.apply(
        null,
        enabledColumns.map((item) => item.level),
      );

      this.$emit("setLevelsTableData", max + 1);
      // this.levels = max + 1;

      this.setTableShadow();
    },
  },

  mounted() {
    this.updatePositionTop();

    console.log(this.data, "!!!")
    window.addEventListener("touchend", this.handleTouchMove, {
      passive: false,
    });
    document.querySelector(".layout").addEventListener("scroll", this.handleLayoutScroll);
    document.querySelector(".ps").addEventListener("scroll", this.handleTableScroll);

    // this.isScroll = this.$refs.wrapper.$el.clientWidth < this.$refs.wrapper.$el.scrollWidth;
    setTimeout(() => {
      this.setTableShadow();
    }, 1500);
  },

  methods: {
    ChangeDriver(record) {
      this.$emit("changeDriver", record);
    },
    recountDriver(record) {
      this.$emit("recountDriver", record);
    },
    getTimeDifference(start, end) {
      const startTime = moment(start, "HH:mm");
      const endTime = moment(end, "HH:mm");

      const duration = moment.duration(endTime.diff(startTime));

      const hours = parseInt(duration.asHours(), 10);

      const minutes = parseInt(duration.asMinutes(), 10) % 60;

      if (hours > 0) return `${hours}ч ${minutes} мин`;
      return `${minutes} мин`;
    },

    numberWithSpaces(x) {
      if (x === null) {
        return null;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },

    handleTableScroll() {
      this.setTableShadow();
    },

    handleTouchMove() {
      // if (!e.cancelable) {
      //   e.preventDefault();
      //   return true
      // }
    },

    setTableShadow() {
      if (this.data.actions === undefined) {
        return;
      }
      const ps = document.querySelector(".ps");
      // const tableWrapper = document.querySelector(".c-table__wrapper");
      const tableWrapperShadow = document.querySelector(".c-table__shadow");

      if (!ps || !tableWrapperShadow) return;

      const fullScrollWidth = ps.scrollWidth - ps.clientWidth;

      const diff = Math.abs(ps.scrollLeft - fullScrollWidth);

      if (diff > 3 && this.data.records.length !== 0) {
        tableWrapperShadow.classList.add("c-table__shadow_active");
      } else {
        tableWrapperShadow.classList.remove("c-table__shadow_active");
      }
    },

    resetColumnFilters() {
      this.activeFilteredColumns = [];

      this.$refs.columnFilters.resetFilters();
    },

    isColumnFiltered(columnId) {
      if (this.filteredColumns === undefined) {
        return false;
      }
      const result = this.filteredColumns.findIndex((i) => i === columnId);

      return result !== -1;
    },

    isColumnActiveFiltered(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      return c !== -1;
    },

    setColumnFilter(e) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === e.id);

      const filterOptions = {
        id: e.id,
        type: e.type,
        searchType: e.filter.condition.value,
        value: e.type === "number" && e.filter.condition.value === "4" ? e.filter.rangeValue : e.filter.value,
      };

      if (
        c === -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        return;
      }

      if (
        c !== -1 &&
        (filterOptions.type === "string" || filterOptions.type === "number") &&
        filterOptions.value === ""
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (
        c === -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        return;
      }

      if (
        c !== -1 &&
        filterOptions.type === "number" &&
        filterOptions.searchType === "4" &&
        (filterOptions.value.end === "" || filterOptions.value.start === "")
      ) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1 && filterOptions.type === "list" && filterOptions.value.length === 0) {
        return;
      }

      if (c !== -1 && filterOptions.value.length === 0) {
        this.activeFilteredColumns.splice(c, 1);
        return;
      }

      if (c === -1) {
        this.activeFilteredColumns.push(filterOptions);
      } else {
        this.activeFilteredColumns.splice(c, 1);
        this.activeFilteredColumns[c] = filterOptions;
      }
    },

    isCategory(column) {
      return column.isCategory === 1;
    },

    isSorted(column) {
      return column.isSorted;
    },

    setSortedColumn(column, sortedColumn) {
      if (column.isCategory !== 1 && sortedColumn !== undefined) {
        const c = this.data.columns.findIndex((i) => i.id === sortedColumn.sortBy);

        if (c !== -1) {
          this.data.columns[c].isSorted = false;
        }

        column.isSorted = true;
        this.sortedColumn.sortBy = column.id;

        if (column.id === sortedColumn.sortBy) {
          this.sortedColumn.sortType = this.sortedColumn.sortType === "asc" ? "desc" : "asc";
        } else {
          this.sortedColumn.sortType = "asc";
        }

        this.$emit("sortedEvent", this.sortedColumn);
      }
    },

    removeColumnFilter(columnId) {
      const c = this.activeFilteredColumns.findIndex((i) => i.id === columnId);

      if (c !== -1) {
        this.activeFilteredColumns.splice(c, 1);
      }
    },

    openColumnFilterModal(column) {
      const c = this.filteredColumns.findIndex((i) => i === column.id);

      if (c !== -1) {
        this.filteredColumn = column;
      }
    },

    handleLayoutScroll() {
      const layout = document.querySelector(".layout");
      const app = document.querySelector(".app");

      let result = layout.scrollTop - this.positionTop;

      if (app.offsetWidth < 992) {
        result += 50;
      }

      if (layout.scrollTop > this.positionTop) {
        if (this.$refs.header) {
          this.$refs.header.classList.add("c-table__header-shadow");
          this.$refs.header.style.transform = `translateY(${result}px)`;
        }
      } else if (this.$refs.header) {
        this.$refs.header.classList.remove("c-table__header-shadow");
        this.$refs.header.style.transform = "none";
      }
    },

    updatePositionTop() {
      const header = this.$refs.header.getBoundingClientRect();
      const layout = document.querySelector(".layout");
      this.positionTop = header.top + layout.scrollTop;
    },

    isDefaultCell(record, column) {
      return !record[column.id].employee && !record[column.id].depositState;
    },

    getChildrens(columnId) {
      return this.data.columns.filter((item) => item.parentColumnId === columnId);
    },

    getTableColumns(level) {
      let out = [];

      const columns = this.data.columns.filter((item) => item.parentColumnId === undefined);

      if (level === 1) {
        out = out.concat(columns);
      } else if (level === 2) {
        Object.keys(columns).forEach((i) => {
          out = out.concat(this.getChildrens(columns[i].id));
        });
      } else if (level === 3) {
        Object.keys(columns).forEach((i) => {
          const childrens = this.getChildrens(columns[i].id);

          Object.keys(childrens).forEach((ii) => {
            out = out.concat(this.getChildrens(childrens[ii].id));
          });
        });
      }

      return out;
    },

    getColumns(level) {
      let cols = [];

      if (level === 1) {
        cols = this.data.columns.filter((col) => col.parentColumnId === undefined);
      } else if (level === 2) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          cols = cols.concat(childrens);
        });
      } else if (level === 3) {
        const rootCols = this.data.columns.filter((col) => col.parentColumnId === undefined);

        Object.keys(rootCols).forEach((i) => {
          const rootCol = rootCols[i];

          const childrens = this.data.columns.filter((col) => col.parentColumnId === rootCol.id);

          Object.keys(childrens).forEach((ii) => {
            const childrens2 = this.data.columns.filter((col) => col.parentColumnId === childrens[ii].id);
            cols = cols.concat(childrens2);
          });
        });
      }

      return cols;
    },

    getColspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      let count = children.length;

      if (column.level === 0) {
        Object.keys(children).forEach((c) => {
          const childrenChildren = this.data.columns
            .filter((col) => col.parentColumnId === children[c].id)
            .filter((colChild) => !this.disabledColumns.includes(colChild.id));

          count += childrenChildren.length;
        });
      }

      Object.keys(children).forEach((i) => {
        const result = this.disabledColumns.find((item) => item === children[i].id || children[i].isCategory === 1);

        if (result) {
          count -= 1;
        }
      });

      return count;
    },

    getRowspan(column) {
      const children = this.data.columns.filter((col) => col.parentColumnId === column.id);

      if (this.levels === 3) {
        if (column.level === 0 && children.length === 0) {
          return 3;
        }
        if (column.level === 1 && children.length === 0) {
          return 2;
        }
      } else if (this.levels === 2) {
        if (column.level === 0 && children.length === 0) {
          return 2;
        }
      }

      return 1;
    },

    getSeletItemLabel(record, column) {
      let cell = null;

      if (column.items) {
        const item = column.items.find((i) => i.value === record[column.name]);

        cell = item ? item.label : "-";
      } else {
        cell = "-";
      }

      return cell;
    },

    scroll() {
      // const layout = document.querySelector(".layout");
      // layout.classList.add('layout-touch-action-none');
      this.isScrolled = this.$refs.wrapper.$el.scrollLeft > 0;
      const containerWidth = this.$refs.container.offsetWidth;
      const wrapperWidth = this.$refs.wrapper.$el.offsetWidth;
      const { scrollLeft } = this.$refs.wrapper.$el;
      this.isScrollEnd = containerWidth - scrollLeft === wrapperWidth - 1;
      // layout.classList.remove('layout-touch-action-none');
    },

    isDisabled(id) {
      return this.disabledColumns.find((item) => item === id);
    },

    getReferenceValues(e) {
      this.$emit("getReferenceValues", e);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";

.c-table {
  position: relative;
  display: inline-block;
  max-width: 100%;

  &__scrollbar-wrapper {
    position: fixed;
    height: 24px;
    background: white;
    box-shadow: $box-shadow;
    bottom: 0;
    left: 0;
    z-index: 100;
    transition: 0.2s;

    @media screen and (max-width: 992px) {
      display: none;
    }
  }

  @media screen and (max-width: 992px) {
    max-width: 100%;
  }

  @media screen and (max-width: 700px) {
    margin: 0 -20px;
    width: calc(100% + 40px);
    max-width: none;
  }

  &__wrapper {
    overflow-x: auto;
    position: relative;
    transition: 0.2s;
    display: inline-block;
    width: 100%;

    &::-webkit-scrollbar {
      height: 0;
    }

    @media screen and (max-width: 992px) {
      width: 100%;
    }
  }

  &__shadow {
    position: absolute;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
    width: 10px;
    height: calc(100% - 10px);
    right: 92px;
    opacity: 0;
    bottom: 10px;
    visibility: hidden;
    z-index: 80;
    transition: 0.2s;
  }

  &__empty__shadow {
    right: 0;
  }

  &__empty__records {
    border: 1px solid $color-border-alt;
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    z-index: $z-index-loader;
    background: white;
    color: $label;
    font-size: 15px;
  }

  &__shadow_active {
    opacity: 0.15;
    visibility: visible;
  }

  &_scroll {
    .c-table__shadow {
      visibility: visible;
      opacity: 0.15;
    }

    .c-table__column_actions {
      &:after {
        visibility: visible !important;
        opacity: 0.15 !important;
      }
    }

    &.c-table_scroll_end {
      .c-table__shadow {
        visibility: hidden;
        opacity: 0;
      }

      .c-table__column_actions {
        &:after {
          visibility: hidden !important;
          opacity: 0 !important;
        }
      }
    }
  }

  &_scrolled {
    border-left: 1px solid $color-border-light;

    @media screen and (max-width: 992px) {
      border-left: none;

      &:before {
        position: absolute;
        content: "";
        width: 22px;
        height: 100%;
        background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0) 100%);
        top: 0;
        left: 0;
        z-index: 100;
      }
    }
  }

  .c-table {
    &__container {
      border-collapse: collapse;
      width: calc(100% - 1px);
    }

    &__header {
      border-bottom: 2px solid $color-border-light;
      position: relative;
      background: $color-border-light;
      z-index: 70;
    }

    &__header-shadow:after {
      content: "";
      position: absolute;
      background: linear-gradient(#001550, rgba(255, 255, 255, 0));
      width: 100%;
      height: 10px;
      opacity: 0.15;
      z-index: 69;
      bottom: -10px;
      left: 0;
    }

    &__column {
      text-align: left;
      border: 1px solid $color-border-light;
      vertical-align: top;
      height: 1px;
      padding: 0;
      transition: 0.2s;

      &_hidden {
        width: 0;
        border: none;
        overflow: hidden;
        display: none;
        // margin-left: -1px;

        .c-table__column-wrapper {
          width: 0;
          padding: 0;
          border: none;
        }
      }

      &_with {
        &_filter {
          .c-table__column {
            &-wrapper {
              flex-direction: column;
            }

            &-actions {
              margin-top: 10px;
            }
          }
        }
      }

      &_sorted {
        .c-table__column-label {
          color: $color-primary;
        }
      }

      &-label {
        color: $color-label;
        font: {
          size: 12px;
          weight: 500;
        }
        line-height: 13px;

        &-children {
          cursor: pointer;
        }
      }

      &-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        height: 100%;
        background: white;
      }

      &-actions {
        display: flex;
        justify-content: space-between;
      }

      &-action {
        width: 14px;
        height: 14px;

        .c-button {
          width: 14px;
          height: 14px;
        }

        &_description {
          margin-left: -3px;
        }
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 30;

        &:after {
          content: "";
          position: absolute;
          background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, #001550 100%);
          width: 10px;
          height: 100%;
          left: -11px;
          opacity: 0;
          bottom: 0;
          visibility: hidden;
          z-index: 40;
        }
      }

      &-empty {
        background: white;
        width: calc(100% + 1px);
        height: calc(100% + 2px);
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        border-bottom: 2px solid $color-border-light;
        margin-left: -1px;
        position: relative;
      }
    }

    &__cell {
      border: 1px solid $color-border-light;
      padding: 0;
      height: 1px;
      transition: 0.2s;

      &__white {
        background: #ffffff;
      }

      &_number {
        & .c-table__cell-value {
          text-align: right;
        }
      }

      &_rank {
        & .c-table__cell-value {
          text-align: left;
        }
      }

      &_hidden {
        width: 0;
        overflow: hidden;
        border: none;
        display: none;

        .c-table__cell-value,
        .c-table__cell-cell {
          width: 0;
          padding: 0;
        }
      }

      &-cell {
        transition: 0.2s;
      }

      &-value {
        line-height: 13px;
        font-size: 13px;
        padding: 10px;
        transition: 0.2s;

        &__processed {
          display: flex;
          justify-content: space-between;
          align-items: center;

          &-button {
            cursor: pointer;
            outline: none;

            &.not-collapsed {
              transform: rotate(-180deg);
              transition: 0.3s transform ease-in-out;
            }
          }
        }
      }

      &-pre-formatted {
        white-space: pre;
      }

      &_actions {
        position: sticky;
        right: 0;
        border-right: none;
        z-index: 20;
      }

      &-actions {
        background: white;
        width: calc(100% + 1px);
        height: 100%;
        display: flex;
        align-items: center;
        border-right: 1px solid $color-border-light;
        border-left: 1px solid $color-border-light;
        margin-left: -1px;
      }
    }
  }

  &__record {
    &-collapse {
      width: 100%;

      &-cell {
        border: 1px solid #dfe4ef;
        padding: 22px 12px;

        &-grey {
          background: #f5f7fa !important;
        }

        @media screen and (max-width: 700px) {
          padding: 18px;
        }
      }

      &-header {
        display: flex;
        justify-content: space-between;

        &-title {
          font-weight: 500;
          font-size: 15px;
          line-height: 100%;
        }

        &-sum {
          font-weight: 500;
          font-size: 15px;
          line-height: 100%;

          &-icon {
            font-size: 13px;
          }
        }
      }

      &-table {
        margin-top: 21px;
        border-width: 1px;
        border-style: solid;
        width: 100%;
        border-color: #dfe4ef;

        &-history-changes {
          margin-bottom: 17px;
        }

        &-row {
          &-red {
            background: #ffd3e8 !important;
            & td {
              background: #ffd3e8 !important;
            }
          }
          &-lightred {
            background: #ffe6f2 !important;
            & td {
              background: #ffe6f2 !important;
            }
          }
          &-yellow {
            background: #fdffb3 !important;
            & td {
              background: #fdffb3 !important;
            }
          }
        }

        &-cell-bold {
          font-weight: 500;
          font-size: 13px;
          line-height: 100%;
        }

        & td {
          height: 38px;
          border-width: 1px;
          padding: 5px 10px;
          border-style: solid;
          border-color: #dfe4ef;
          vertical-align: middle;
          font-size: 13px;
          line-height: 115%;
        }
      }

      &-row {
        margin-top: 24px;
        display: flex;
        justify-content: space-between;

        @media screen and (max-width: 700px) {
          flex-direction: column;
        }

        &-col {
          display: flex;
          flex-direction: column;

          @media screen and (max-width: 700px) {
            width: 100%;
          }

          &:first-child {
            max-width: calc(33% - 15px);
            width: 100%;

            @media screen and (max-width: 700px) {
              max-width: 100%;
            }
          }

          &:last-child {
            max-width: calc(67% - 15px);
            width: 100%;
            @media screen and (max-width: 700px) {
              max-width: 100%;
            }
          }

          &-title {
            font-weight: 500;
            font-size: 15px;
            line-height: 100%;
          }

          &-operator {
            width: 100%;
            display: flex;
            flex-direction: column;

            &-title {
              font-weight: 500;
              font-size: 15px;
              line-height: 100%;
              margin-bottom: 5px;
            }

            &-name {
              font-size: 13px;
              line-height: 120%;
            }
          }

          &-driver {
            width: 100%;
            margin-top: 25px;

            &-title {
              font-weight: 500;
              font-size: 15px;
              line-height: 100%;
              margin-bottom: 5px;
            }
          }

          &-delivery {
            margin-top: 27px;
            display: flex;
            flex-direction: column;

            &-title {
              font-weight: 500;
              font-size: 15px;
              line-height: 100%;
            }

            &-items {
              display: flex;
              flex-direction: column;
              margin-top: 15px;

              &-item {
                display: flex;
                font-size: 13px;
                line-height: 120%;
                margin-top: 9px;

                &:first-child {
                  margin-top: 0;
                }

                & svg {
                  margin-right: 9px;
                }
              }
            }
          }
        }
      }

      &-routes-order-table {
        width: 100%;
        border-width: 1px;
        border-style: solid;
        border-color: #dfe4ef;
      }
    }

    &__total {
      padding: 14px 13px;
      display: flex;
      background: #f5f7fa;

      &__cell {
        border: solid 1px #dfe4ef;
      }

      &__value {
        display: flex;
        align-items: center;
        width: 20%;

        @media screen and (max-width: 800px) {
          width: 50%;
        }

        &__desc {
          color: #8e9cbb;
          font-size: 13px;
          line-height: 100%;
        }

        &__count {
          margin-left: 3px;
          font-size: 15px;
          line-height: 100%;
          font-weight: 500;
        }
      }
    }
  }
}
::v-deep .ps__rail-x {
  z-index: 351;
  background: #ffffff !important;
}

::v-deep .ps__rail-x:before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  transform: translate(-30px, 0);
  box-shadow: 0px 0px 15px rgba(0, 21, 80, 0.3);
  z-index: -1;
  height: 24px;
  width: calc(100vw - 60px);
  background: #ffffff;
}

::v-deep .ps__rail-x:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, calc(-50% + 1px));
  border-radius: 10px;
  z-index: -1;
  height: 4px;
}

::v-deep .c-table__record + tr.collapse {
}

.order_warning td {
  background-color: #ffd3e8!important;
}
</style>
